import { Tooltip } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import { CheckPosition } from "../Function/CheckPosition";
import axios from "axios";
import { GetCookieToken } from "../Cookie/GetCookie";
import Lottie from "react-lottie";
import * as loadingBar from "../TESTPage/loadingBar.json";
import { useGetPositionConText } from "../Context/PositionContext";
import { useGetPositionSubAdminConTextConText } from "../Context/PositionSubAdminConText";
import { positions } from "slate";

const subMenu = [
  {
    id: 1,
    icon: "fa-solid fa-nfc-magnifying-glass",
    name: "ค้นหารายงาน",
    path: "setdata?menuName=1",
  },
  // {
  //   id: 2,
  //   icon: "fa-solid fa-user-magnifying-glass",
  //   name: "ค้นหาข้อมูลคำขอ",
  //   path: "setdata?menuName=2",
  // },
   
  //👆ค้นหาข้อมูลคำขอให้มีการปิดไว้ก่อน

  {
    id: 2,
    icon: "fa-solid fa-landmark-magnifying-glass",
    name: "ค้นหาข้อมูลเข้าทำงาน",
    path: "setdata?menuName=2",
  },
  // {
  // id: 4,
  //   icon: <i className="fa-solid fa-user-gear font-size-20"></i>,
  //   name: "จัดการข้อมูลพนักงาน",
  //   path: "setdata?menuName=4",
  // },
  {
    id: 3,
    icon: "fa-solid fa-magnifying-glass-location",
    name: "ค้นหาข้อมูล",
    path: "setdata?menuName=3",
  },
  {
    id: 4,
    icon: "fa-solid fa-person-walking-dashed-line-arrow-right",
    name: "ขอกลับก่อนเวลา",
    path: "setdata?menuName=4",
  },
];

const SubMenuEntryWork = ({ menu }) => {

  const baseURL = process.env.REACT_APP_API_CORS
  const token = GetCookieToken("userToken")
  const navigate = useNavigate();

  const {position, setPosition} = useGetPositionConText()
  const {positionSubAdmin, setPositionSubAdmin} = useGetPositionSubAdminConTextConText()

  const [viewSubMenu, setViewSubMenu] = useState();
  const [loading, setLoading] = useState(false);
  const [checkSubAdmin, setCheckSubAdmin] = useState(false)

  useEffect(() => {
        if ((positionSubAdmin?.length > 0 && 
            (positionSubAdmin?.includes(0) ||
            positionSubAdmin?.includes(2))) ||
            position?.length > 0) {
              setCheckSubAdmin(true)
            }
  }, [positionSubAdmin,position]);

  // useEffect(() => {
  //   setLoading(true)
  //   setViewSubMenu(
  //     CheckSubAdmin(positionSubAdmin) ||
  //       CheckPosition(position)
  //   );
  //   setTimeout(() => {
  //     setLoading(false)
  //   }, 1500);
  // }, []);

  return (
    <Fragment>
      <Row>
        <Col className="custom-menu">
          <Tooltip title="หน้าหลัก">
            <button
              className={
                !menu
                  ? "rounded-pill btn btn-primary"
                  : "rounded-pill btn btn-outline-primary"
              }
              onClick={() => {
                navigate(`/entrywork`);
              }}
            >
              <Row>
                <Col className="d-flex justify-content-center">
                  <i
                    className="fa-solid fa-house"
                    style={{
                      paddingLeft: "0.1rem",
                      paddingRight: "0.1rem",
                    }}
                  ></i>
                   {!menu && (
                      <Col lg={9}>
                        <FadeIn>
                          <span
                            style={{ whiteSpace: "nowrap" }}
                            className="text-center ps-2"
                            // style={{ paddingRight: "1.8rem" }}
                          >
                            หน้าหลัก
                          </span>
                        </FadeIn>
                      </Col>
                    )}
                </Col>
              </Row>
            </button>
          </Tooltip>
          {(checkSubAdmin)
           ? (
            <>
              {subMenu &&
                subMenu?.map((item, idx) => {
                  if (Number(menu) === Number(item?.id) && 4 !== Number(item?.id)) {
                    return (
                      <Tooltip key={idx} title={item?.name}>
                        <button
                          className={"rounded-pill btn btn-primary"}
                          onClick={() => {
                            navigate(`/entrywork/${item?.path}`);
                          }}
                        >
                          <Row>
                            <Col className="d-flex justify-content-center">
                                <i
                                  className={item?.icon}
                                  style={{
                                    paddingLeft: "0.1rem",
                                    paddingRight: "0.1rem",
                                  }}
                                ></i>
                                    <FadeIn>
                                      <span
                                        className="ps-1"
                                        style={{ paddingRight: "1.8rem" }}
                                      >
                                        {item?.name}
                                      </span>
                                    </FadeIn>
                            </Col>
                          </Row>
                        </button>
                      </Tooltip>
                      // ""
                    );
                  } else {
                    if (4 !== Number(item?.id)) {
                      return (
                        <Tooltip key={idx} title={item?.name}>
                          <button
                            className={"rounded-pill btn btn-outline-primary"}
                            onClick={() => {
                              navigate(`/entrywork/${item?.path}`);
                            }}
                          >
                            <Row>
                              <Col lg={2}>
                                <i
                                  className={item?.icon}
                                  style={{
                                    paddingLeft: "0.1rem",
                                    paddingRight: "0.1rem",
                                  }}
                                ></i>
                              </Col>
                            </Row>
                          </button>
                        </Tooltip>
                        // ""
                      );
                    }
                  }
                })}
            </>
          ) : (
            <>
              <Tooltip title="ค้นหาข้อมูล">
                <button
                  className={
                    menu === 3
                      ? "rounded-pill btn btn-primary"
                      : "rounded-pill btn btn-outline-primary"
                  }
                  onClick={() => {
                    navigate(`/entrywork/setdata?menuName=3`);
                  }}
                >
                  <Row>
                    <Col className="d-flex justify-content-center">
                      <i className="fa-solid fa-magnifying-glass-location" style={{
                            paddingLeft: "0.1rem",
                            paddingRight: "0.1rem",
                          }}></i>
                      {menu === 3 && (
                          <Col lg={9}>
                            <FadeIn>
                              <span
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center ps-2"
                                // style={{ paddingRight: "1.8rem" }}
                              >
                                ค้นหาข้อมูล
                              </span>
                            </FadeIn>
                          </Col>
                        )}
                    </Col>
                  </Row>
                </button>
              </Tooltip>
              {/* <Tooltip title="ขอกลับก่อนเวลา">
                <button
                  className={
                    menu === 4
                      ? "rounded-pill btn btn-primary"
                      : "rounded-pill btn btn-outline-primary"
                  }
                  onClick={() => {
                    navigate(`/entrywork/setdata?menuName=4`);
                  }}
                >
                  <Row>
                    <Col className="d-flex justify-content-center">
                      <i
                          className="fa-solid fa-person-walking-dashed-line-arrow-right"
                          style={{
                            paddingLeft: "0.1rem",
                            paddingRight: "0.1rem",
                          }}
                        ></i>
                      {menu === 4 && (
                          <Col lg={9}>
                            <FadeIn>
                              <span
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center ps-2"
                                // style={{ paddingRight: "1.8rem" }}
                              >
                                ขอกลับก่อนเวลา
                              </span>
                            </FadeIn>
                          </Col>
                        )}
                    </Col>
                  </Row>
                </button>
              </Tooltip> */}
            </>
          )}
        </Col>
      </Row>
    </Fragment>
  );
};

export default SubMenuEntryWork;
